import { t } from "i18next";

export default function validate(values) {

  let errors = {};

  const requiredFields = true;
  const validateRegexFields = true;
  const validateSize = true;

  const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
  const regexPassword = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\!\@\#\$\%\^\&\*\_\+\=\:\;\,\.\<\>]).*$/;

  if (requiredFields) {
    //console.log("Caso A, requiredFields");
    if (!values.email) {
      addMessageToErrors(`* ${t("validations.email-login")} ${t("validations.required")}`, "email", errors);
    }

    if (!values.password) {
      addMessageToErrors(`* ${t("validations.password-login")} ${t("validations.required")}`, "password", errors);
    }
  }

  if (validateSize) {
    //console.log("Caso B, validateSize")
    if (values.password !== "") {
      if (values.password.length < 8 || values.password.length > 16) {
        
        addMessageToErrors(`* ${t("validations.password-length")}`, "password", errors);
      }
    }
  }

  if (validateRegexFields) {
    //console.log("Caso C, validateRegexFields")
    if (values.email !== "") {
      if (!regexEmail.test(values.email)) {
        addMessageToErrors(`* ${t("validations.email-login")} ${t("validations.email-format")}`, "email", errors);
        
      }
    }

    if (values.password !== "") {
      if (!regexPassword.test(values.password)) {
        const hasUpperCase = /(?=.*[A-Z])/.test(values.password);
        const hasLowerCase = /(?=.*[a-z])/.test(values.password);
        const hasNumber = /(?=.*[0-9])/.test(values.password);
        
        const hasSpecialChar = /(?=.*[\!\@\#\$\%\^\&\*\_\+\=\:\;\,\.\<\>])/.test(values.password);

        if (!hasUpperCase) addMessageToErrors(`* ${t("validations.password-uppercase")}`, "password", errors);
        if (!hasLowerCase) addMessageToErrors(`* ${t("validations.password-lowercase")}`, "password", errors);
        if (!hasNumber) addMessageToErrors(`* ${t("validations.password-number")}`, "password", errors);
        if (!hasSpecialChar) addMessageToErrors(`* ${t("validations.password-special")}`, "password", errors);
        if (!hasSpecialChar) addMessageToErrors(`* ${t("validations.password-special-permitted")}`, "password", errors);

      }
    }
  }

  return errors;
};

const addMessageToErrors = (textToAdd, field, errorsLocal) => {
  //console.log("addMessageToErrors, field, textToAdd", field, textToAdd)
  if (errorsLocal[field]) {
    errorsLocal[field] = `${errorsLocal[field]}\n${textToAdd}`;
  } else {
    errorsLocal[field] = `${textToAdd}`;
  }
}
